<template>
  <div id="contractResume">
    <div class="row  mx-1" v-if="!$store.state.roles.Backoffice_member_empresas">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Terminal</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Proveedor</div>
            <p>{{ contractData.product.supplier || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Marca</div>
            <p>{{ contractData.product.brand || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Stock</div>
            <p>{{ contractData.product.stock > 0 ? 'Sí' : 'No' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Modelo</div>
            <p>{{ contractData.product.model || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Color</div>
            <p>{{ contractData.product.color || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Capacidad</div>
            <p>{{ contractData.product.capacity || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Cuota mensual</div>
            <p>{{ contractData.product.quotaPrice + '€' || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Nº Cuotas</div>
            <p>{{ contractData.product.nQuotas || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Total</div>
            <p>{{ contractData.product.price + '€' || '-' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row  mx-1" v-if="!$store.state.roles.Backoffice_member_empresas">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Datos cliente</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Nombre</div>
            <p>{{ contractData.customer.name }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Apellido 1</div>
            <p>{{ contractData.customer.surname1 }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Apellido 2</div>
            <p>{{ contractData.customer.surname2 }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Tipo documento</div>
            <p>{{ contractData.customer.documentType || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Nº Documento</div>
            <p>{{ contractData.customer.legalIdentifier || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Teléfono</div>
            <p>{{ contractData.customer.mobile || '-' }}</p>
          </div>
          <!--<div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Teléfono fijo</div>
            <p>{{ contractData.customer.telephone || '-' }}</p>
          </div>-->
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Fecha nacimiento</div>
            <p>{{ contractData.customer.birthdate || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Email</div>
            <p>{{ contractData.customer.email || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Idioma preferido</div>
            <p>{{ contractData.customer.language || '-' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row  mx-1" v-if="$store.state.roles.Backoffice_member_empresas">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Dispositivos</div>
        </div>
        <div style="display: flex; justify-content: center;" v-if="loadingProducts">
          <img src="../../../../../assets/loaderPrimary.svg" height="200" alt="">
        </div>
        <div class="overflow-auto" v-if="!loadingProducts">          
          <table class="table">
            <thead>
              <tr>
                <th class="align-middle" colspan="5" style="text-align: center; width: 80%; background-color: #cc0b7a; color:white; border-right: 6px double white; border-top: 3px solid #cc0b7a; border-left: 3px solid #cc0b7a;">
                  PRODUCTO UNITARIO
                </th>
                <th class="align-middle" colspan="2" style="text-align: center; width: 20%; background-color: #cc0b7a; color:white; border-right: 3px solid #cc0b7a; border-top: 3px solid #cc0b7a;">
                  TOTALES
                </th>
              </tr>
            </thead>
            <thead>
              <tr style="background-color: #edbcd9;">
                <th class="align-middle" style="border-left: 3px solid #cc0b7a;">
                  Nombre
                </th>
                <th class="align-middle" style="width: 2%; min-width: 90px;">
                  Precio
                </th>
                <th class="align-middle">
                  Impuesto
                </th>
                <th class="align-middle">
                  {{ policyDisplayLabel }}
                </th>
                <th class="align-middle" style="width: 10%; min-width: 75px; border-right: 6px double #cc0b7a;">
                  Cuota
                </th>
                <th class="align-middle" style="text-align: center;">
                  Unidades
                </th>
                <th class="align-middle" style="width: 10%; min-width: 90px; text-align: center; border-right: 3px solid #cc0b7a;">
                  Cuota
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="justify-content-center" v-for="(product) in contractData.product"
                v-bind:key="product.partCode" style="border-left: 3px solid #cc0b7a;">
                <td class="align-middle" style="width: 20%;">{{ product.name }}</td>
                <td class="align-middle">
                  <span style="display: flex; align-items: center; gap:3px;">
                    <input type="number" class="form-control generalInput typeNumber" style="max-width: 70px;"
                    v-model.trim="product.payment.monthlyNetFee" @blur="abrirCalculo()" @keyup="abrirCalculoEnter($event)" @focus="calculated = false">
                    €
                  </span>
                </td>
                <td class="align-middle" style="width: 8%;">{{ product.payment.taxBase.toFixed(2) }} €
                </td>
                <td class="align-middle" style="width: 10%;">{{ product.policy.monthlyGrossPolicy.toFixed(2) }} €
                </td>
                <td class="align-middle" style="border-right: 6px double #cc0b7a;">{{ product.payment.totalFee.toFixed(2) }} €
                </td>
                <td class="align-middle" style="text-align: center;">{{ product.quantity }}</td>
                <td class="align-middle" style="text-align: center;border-right: 3px solid #cc0b7a; background-color: #f8e7f1;">{{ product.totalFee.toFixed(2) }} €
                </td>
              </tr>
              <tr class="justify-content-center" style="border-top: 3px double #cc0b7a;border-left: 3px solid #cc0b7a;border-right: 3px solid #cc0b7a;border-bottom: 3px solid #cc0b7a;">
                <td class="align-middle"><strong>TOTAL: </strong></td>
                <td class="align-middle"><strong>{{ totalmonthlyNetFeeUnity }} €</strong></td>
                <td class="align-middle"><strong>{{ totalTaxBaseUnity }} €</strong></td>
                <td class="align-middle"><strong>{{ totalmonthlyGrossPolicyUnity }} €</strong></td>
                <td class="align-middle" style="border-right: 6px double #cc0b7a;"><strong>{{ totalFeeUnity }} €</strong></td>
                <td class="align-middle" style="text-align: center;">{{ totalQuatity }}</td>
                <td class="align-middle" style="text-align: center; background-color: #f8e7f1;"><strong>{{ totalFee }} €</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row  mx-1" v-if="$store.state.roles.Backoffice_member_empresas">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Datos cliente</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Nombre de la empresa</div>
            <p>{{ contractData.customer.name }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">CIF</div>
            <p>{{ contractData.customer.legalIdentifier }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Teléfono</div>
            <p>{{ contractData.customer.phone }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">CNAE</div>
            <p>{{ contractData.customer.cname }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$store.state.roles.Backoffice_member_empresas">
      <div class="row  mx-1" v-for="(item, index) in contractData.customer.companyContact" v-bind:key="index">
        <div class="col-12">
          <div class="mb-3">
            <div class="generalSubtitle">Autorizado {{ index + 1 }}</div>
          </div>
          <div class="row">
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Nombre</div>
              <p>{{ item.name }}</p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">DNI</div>
              <p>{{ item.legalIdentifier }}</p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Movil</div>
              <p>{{ item.mobile }}</p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Email</div>
              <p>{{ item.email }}</p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Poderes</div>
              <p>{{ item.powers }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row  mx-1">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Dirección</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Calle</div>
            <p>{{ contractData.customer.deliveryAddress.street || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Número</div>
            <p>{{ contractData.customer.deliveryAddress.number || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Piso</div>
            <p>{{ contractData.customer.deliveryAddress.floor || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Puerta</div>
            <p>{{ contractData.customer.deliveryAddress.door || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Escalera</div>
            <p>{{ contractData.customer.deliveryAddress.stair || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Código postal</div>
            <p>{{ contractData.customer.deliveryAddress.postalCode || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Localidad</div>
            <p>{{ contractData.customer.deliveryAddress.city || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Provincia</div>
            <p>{{ contractData.customer.deliveryAddress.province || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">País</div>
            <p>{{ contractData.customer.deliveryAddress.country || '-' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Dirección de facturación</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Calle</div>
            <p>{{ contractData.customer.billingAddress.street || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Número</div>
            <p>{{ contractData.customer.billingAddress.number || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Piso</div>
            <p>{{ contractData.customer.billingAddress.floor || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Puerta</div>
            <p>{{ contractData.customer.billingAddress.door || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Escalera</div>
            <p>{{ contractData.customer.billingAddress.stair || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Código postal</div>
            <p>{{ contractData.customer.billingAddress.postalCode || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Localidad</div>
            <p>{{ contractData.customer.billingAddress.city || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Provincia</div>
            <p>{{ contractData.customer.billingAddress.province || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">País</div>
            <p>{{ contractData.customer.billingAddress.country || '-' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-1">
      <div class="col-12">
        <button class="btn btn-outline-secondary float-left generalSecondaryButton" @click="goBack($event)">Atrás</button>
        <router-link class="btn btn-outline-secondary float-left generalSecondaryButton ml-3"
          :to="{ name: 'newContractStep1' }" @click="removeStorage()">Cancelar</router-link>


        <button class="btn btn-primary float-right generalPrimaryButton"
                :class="{ disabled: comprobarContratarDisabled() || loading }"
                :disabled="comprobarContratarDisabled() || loading"
                @click="submit">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-if="loading">Procesando...</span>
          <span v-else>Contratar</span>
        </button>
      </div>
    </div>
  </div>

  <NotificationActions v-if="notification.show" :message="notification.message" :type="notification.type" />

  <ModalFinal :id="'finalModal'" :modalTitle="'Paso final'" :class="'modal'" :showFooter="false" />
  <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
    :message="errorMessage" :code="errorCode" />
  <CalculateModal :id="'calculateModal'" :modalTitle="'Calculo'" :class="'modal-xl'" :showFooter="false"
    :product="productCalculate" @submit="submit()" />
</template>
<script>
import axios from 'axios';
import ModalFinal from '../SuccessModal/FinalModal.vue';
import ModalError from '../../../Shared/ModalError.vue';
import CalculateModal from './templates/CalculateModal.vue';
import NotificationActions from "@/components/Widgets/Shared/NotificationActions.vue";
import { Modal as ModalBootstrap } from "bootstrap";
export default {
  name: 'ResumeContract',
  data() {
    return {
      contractData: this.$store.state.newContractData,
      errorMessage: '',
      errorCode: '',
      productCalculate: [],
      calculated: false,
      totalmonthlyNetFeeUnity: 0,
      totalTaxBaseUnity: 0,
      totalmonthlyGrossPolicyUnity: 0,
      totalFeeUnity: 0,
      totalQuatity: 0,
      totalFee: 0,
      loadingProducts: false,
      loading: false,
      isInitialCalculate: true,
      notification: {
        show: false,
        message: '',
        type: ''
      }
    };
  },
  computed: {
    policyDisplayLabel() {
      const policyType = this.contractData?.product?.[0]?.policy?.policyType;
      return this.buildPolicyLabel(policyType);
    }
  },
  created() {
    console.log('[Resume] Componente creado, verificando productos...');
    if (this.$store.state.roles.Backoffice_member_empresas){
      // Asegurar que el cálculo se complete correctamente
      this.$nextTick(() => {
        console.log('[Resume] Iniciando cálculo automático de precios...');
        this.abrirCalculo();
      });
    }
  },
  components: {
    ModalFinal,
    ModalError,
    CalculateModal,
    NotificationActions
  },
  methods: {

    showNotification(message, type) {
      this.notification.message = message;
      this.notification.type = type;
      this.notification.show = true;
      setTimeout(() => {
        this.notification.show = false;
      }, 5000);
    },
    comprobarContratarDisabled() {
      if (!this.$store.state.roles.Backoffice_member_empresas) return false;

      // Verificar que existan productos
      if (!this.contractData.product || this.contractData.product.length === 0) {
        console.warn('[Resume] No hay productos en el contrato');
        return true;
      }

      // Validar solo campos esenciales
      const hasInvalidProducts = this.contractData.product.some(product => {
        const isInvalid = !product.payment ||
                         !product.policy ||
                         !product.payment.monthlyNetFee ||
                         product.payment.monthlyNetFee <= 0;

        if (isInvalid) {
          console.warn('[Resume] Producto inválido:', {
            name: product.name || 'Sin nombre',
            monthlyNetFee: product.payment?.monthlyNetFee,
            hasPayment: !!product.payment,
            hasPolicy: !!product.policy
          });
        }

        return isInvalid;
      });

      if (!this.calculated) {
        console.warn('[Resume] El cálculo de precios no se ha completado');
      }

      return hasInvalidProducts || !this.calculated;
    },


    submit() {
      this.loading = true;
      let bodyToSend = this.$store.state.newContractData;
      if (!this.$store.state.roles.Backoffice_member_empresas) {
        bodyToSend.channel = 'PHYS';
        bodyToSend.customer.title = '';
        bodyToSend.customer.surnames = bodyToSend.customer.surname1 + " " + bodyToSend.customer.surname2;
        if (bodyToSend.customer.birthdate.includes('/'))
          bodyToSend.customer.birthdate = this.$dateFrontToBack(bodyToSend.customer.birthdate);
      } else {
        bodyToSend.products = bodyToSend.product;
        bodyToSend.customer.companyContact.forEach((contact) => {
          if (contact.powers == 'Si') contact.powers = true
          else contact.powers = false
        })
      }
      bodyToSend.customer.deliveryAddress.number = bodyToSend.customer.deliveryAddress.number +
        (bodyToSend.customer.deliveryAddress.door && !bodyToSend.customer.deliveryAddress.number.includes('Puerta') ? ' Puerta ' + bodyToSend.customer.deliveryAddress.door : '') +
        (bodyToSend.customer.deliveryAddress.floor && !bodyToSend.customer.deliveryAddress.number.includes('Planta') ? ' Planta ' + bodyToSend.customer.deliveryAddress.floor : '') +
        (bodyToSend.customer.deliveryAddress.stair && !bodyToSend.customer.deliveryAddress.number.includes('Escalera') ? ' Escalera ' + bodyToSend.customer.deliveryAddress.stair : '')
      bodyToSend.customer.billingAddress.number = bodyToSend.customer.billingAddress.number +
        (bodyToSend.customer.billingAddress.door && !bodyToSend.customer.billingAddress.number.includes('Puerta') ? ' Puerta ' + bodyToSend.customer.billingAddress.door : '') +
        (bodyToSend.customer.billingAddress.floor && !bodyToSend.customer.billingAddress.number.includes('Planta') ? ' Planta ' + bodyToSend.customer.billingAddress.floor : '') +
        (bodyToSend.customer.billingAddress.stair && !bodyToSend.customer.billingAddress.number.includes('Escalera') ? ' Escalera ' + bodyToSend.customer.billingAddress.stair : '')
      let urlOrder = '/order';
      if (this.$store.state.roles.Backoffice_member_empresas) urlOrder = '/business' + urlOrder;
      axios.post(urlOrder, bodyToSend)
        .then((response) => {
          console.log(response);
          this.loading = false;
          this.removeStorage()
          var myModal = new ModalBootstrap(document.getElementById('finalModal'))
          myModal.show()
        })
        .catch((error) => {
          this.loading = false;
          this.errorCode = error.response?.data?.code || 'No definido';
          this.errorMessage = error.response?.data?.message || 'Ha ocurrido un error, inténtelo más tarde.';

          this.errorCode = error.response?.data?.code;
          this.showNotification(`Error (${this.errorCode}): ${this.errorMessage}`, 'error');
          if (this.errorCode && this.errorCode != '') {
            this.errorMessage = error.response.data.message;
            if( error.response.data.errors ){
              error.response.data.errors.forEach((e) => {
                this.errorMessage += ': * ' + e.message;
              })
            }
          }else {
            this.errorCode = 'No definido';
            this.errorMessage = 'Ha ocurrido un error, inténtelo de nuevo más tarde. Si es un error 504 verifique si se ha llegado a crear el contrato antes de volver a lanzarlo.';
          }
          
          var myModal = new ModalBootstrap(document.getElementById('modalError'))
          myModal.show()
        });
    },
    goBack(event) {
      event.preventDefault();
      this.$router.push({ name: 'newContractStep2' })
    },
    buildPolicyLabel(policyType) {
      const commercialName = {
        ESSENTIAL: 'Basic',
        TOTAL: 'Premium',
        MAINTENANCE: 'Rentik Care'
      }[policyType] || policyType || '';
      const prefix = policyType === 'MAINTENANCE' ? 'Servicio' : 'Seguro';
      return `${prefix} '${commercialName}'`;
    },
    abrirCalculoEnter(event) {
      if (event.key === 'Enter') {
        this.abrirCalculo();
      }
    },
    abrirCalculo() {
      console.log('[Resume] Iniciando abrirCalculo()...');

      // Validar que haya productos antes de calcular
      if (!this.contractData.product || this.contractData.product.length === 0) {
        console.error('[Resume] No hay productos para calcular');
        this.loadingProducts = false;
        this.showNotification('No hay productos en el contrato para calcular', 'error');
        return;
      }

      // Validar que haya código postal de facturación
      if (!this.contractData.customer?.billingAddress?.postalCode) {
        console.error('[Resume] Falta código postal de facturación');
        this.loadingProducts = false;
        this.showNotification('Falta el código postal de facturación', 'error');
        return;
      }

      let productsArray = []
      this.loadingProducts = true;

      this.contractData.product.forEach((element, index) => {
        // Validar campos esenciales de cada producto
        if (!element.partCode) {
          console.warn(`[Resume] Producto ${index} sin partCode`);
        }

        const payment = this.isInitialCalculate
          ? {}
          : { monthlyNetFee: element.payment?.monthlyNetFee || 0 };

        productsArray.push({
          partCode: element.partCode,
          quantity: element.quantity || 1,
          payment,
          policy: element.policy || {},
          policyOptions: element.policyOptions || {},
        },)
      });

      let bodyToSend = {
        billingPostalCode: this.contractData.customer.billingAddress.postalCode,
        products: productsArray
      }

      console.log('[Resume] Enviando cálculo a API:', bodyToSend);

      axios.post('/business/billing/calculate', bodyToSend)
        .then((response) => {
          console.log('[Resume] Cálculo completado exitosamente:', response.data);

          let totalQuantity = 0;
          let totalmonthlyNetFeeUnity = 0;
          let totalTaxBaseUnity = 0;
          let totalmonthlyGrossPolicyUnity = 0;
          let totalFeeUnity = 0;
          this.productCalculate = response.data;
          this.contractData.product.forEach((element, index) => {
            totalQuantity = totalQuantity + this.productCalculate.products[index].quantity;
            this.productCalculate.products[index].name = element.name;
          });
          this.productCalculate.products.forEach((product) => {
            totalmonthlyNetFeeUnity = totalmonthlyNetFeeUnity + product.payment.monthlyNetFee;
            totalTaxBaseUnity = totalTaxBaseUnity + product.payment.taxBase;
            totalmonthlyGrossPolicyUnity = totalmonthlyGrossPolicyUnity + product.policy.monthlyGrossPolicy;
            totalFeeUnity = totalFeeUnity + product.payment.totalFee;
          });
          this.contractData.product = this.productCalculate.products;
          this.totalFee = this.productCalculate.totalFee;
          this.totalmonthlyNetFeeUnity = totalmonthlyNetFeeUnity.toFixed(2);
          this.totalTaxBaseUnity = totalTaxBaseUnity.toFixed(2);
          this.totalmonthlyGrossPolicyUnity = totalmonthlyGrossPolicyUnity.toFixed(2);
          this.totalFeeUnity = totalFeeUnity.toFixed(2);
          this.totalQuatity = totalQuantity;
          this.$store.commit('setNewContractDataProduct', this.productCalculate.products);
          // var myModal = new ModalBootstrap(document.getElementById('calculateModal'))
          // myModal.show()
          this.calculated = true
          this.loadingProducts = false;
          this.isInitialCalculate = false;
          console.log('[Resume] Botón "Contratar" ahora debería estar habilitado');
        })
        .catch((error) => {
          console.error('[Resume] Error al calcular precios:', error);
          this.loadingProducts = false;
          this.calculated = false;

          this.errorCode = error.response?.data?.code || 'ERROR_CALCULO';
          this.errorMessage = error.response?.data?.message || 'Error al calcular los precios del contrato';

          this.showNotification(`Error al calcular: ${this.errorMessage}`, 'error');

          var myModal = new ModalBootstrap(document.getElementById('modalError'))
          myModal.show()
        });


    },
    comprobarDatosFranquicia() {
      let value = false
      if (this.$store.state.roles.Backoffice_member_empresas) {
        this.contractData.product.forEach((element) => {
          if (element.rentalPrice < 1 || element.policy.repairExcess < 1 || element.policy.replacementExcess < 1 || !this.calculated) {
            value = true
          }
        })
      }
      return value
    },
    removeStorage() {
      this.$store.commit('RESET_STATE_CONTRACTS');
    },
    comprobarQuantity() {
      let value = false
      if (this.$store.state.roles.Backoffice_member_empresas) {
        this.contractData.product.forEach(producto => {
          if (producto.payment.rentServ < 1 || producto.policy.monthlyGrossPolicy < 1) value = true
        });
      }
      return value
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.typeNumber::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.typeNumber {
  appearance: textfield;
}
</style>